import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-circular-loader',
  templateUrl: './circular-loader.component.html',
  styleUrls: ['./circular-loader.component.css']
})
export class CircularLoaderComponent implements OnInit {

  @Input() primary: boolean | undefined = true;

  constructor() { }

  ngOnInit(): void {
  }

}
